import { mutator } from 'satcheljs';
import { onSavingChanged } from '../actions/onSavingChanged';
import { getAppStore } from '../store/store';

mutator(onSavingChanged, msg => {
  getAppStore().saving = msg.saving;
});
